.icon {
  display: flex;
  flex-direction: row;
  align-items: center;

  height: 12px;
  width: 12px;
  color: var(--grey-600);
}
